import { type Country } from '@tectonics/prs/country';
import { stripNonMatching } from '@tectonics/utils/formatting';
import type { Maybe } from '@tectonics/utils/types';

const countryNormalizerLengthMap: Map<Country, number> = new Map([
  ['br', 8],
  ['gh', 8],
  ['mx', 5],
  ['pe', 5],
  ['bo', 5],
  ['cr', 5],
  ['py', 5],
  ['pa', 5],
  ['do', 5],
  ['sv', 5],
  ['gt', 5],
  ['eg', 5],
  ['jm', 5],
  ['tr', 5],
  ['my', 5],
  ['id', 5],
  ['ar', 4],
  ['co', 6],
  ['uy', 6],
  ['cl', 7],
  ['ec', 7],
  ['za', 7],
  ['ke', 9],
  ['tz', 9],
  ['ug', 9],
  ['ng', 6],
  ['zm', 6],
  ['in', 6],
  ['ph', 6],
]);

export function getZipcodeNormalizer(country: Country): (zipcode: Maybe<string>) => string {
  return (zipcode: Maybe<string>) => {
    if (!zipcode) {
      return '';
    }

    const expectedLength = countryNormalizerLengthMap.get(country);

    if (expectedLength === undefined) {
      throw new Error(`No zipcode normalizer configuration found for country: ${country}`);
    }

    return stripNonMatching(zipcode, 'numeric').slice(0, expectedLength);
  };
}
